<template>

  <div class="feedItem panel bg-lightest black d-flex px-3">
    <div class="col-md-2 text-center p-0 align-middle h-100 mr-2">
      <img class="" src="static/images/dashboard/tasksCompletedSmile.png">
    </div>
    <div class="col-md-10 fc-dark align-middle h-100">
      <div class="font-weight-600 fs-large mb-2">Well Done.</div>
      <div>You can now see your operation business<br> operation feed. Start selling some products.</div>
    </div>
  </div>

</template>

<script>

export default {
  data: function() {
    return{
    }
  },
  props: {
    cardInfo: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .panel{
    height: 120px !important;
  }

</style>



// WEBPACK FOOTER //
// FeedcardTaskscompleted.vue?26517bf8